import React, {useRef,useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import IconButton from '@mui/material/IconButton'; 
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import TypesDISearchStores from "./TypesDISearchStores";
import TypesDISearchStoresAddress from "./TypesDISearchStoresAddress";
import TypesDISearchStoresNimaAddresses from "pages/typesDIFormat/typesDIEdit/TypesDISearchStoresNimaAddress";
import TypesDISearchVehicles from "./TypesDISearchVehicles";
import PropTypes from 'prop-types';

const initialPostalCodetoSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const TypeDICreateOrEditAutDest = ({formForm,setFormForm,errorsForm,setErrorsForm,validateForm,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect}) => {
    const {t,i18n} = useTranslation(['listDataForms']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);       
    const [showModalSearchVehicles, setShowModalSearchVehicles] = useState(false); 
    const dispatch = useDispatch(); 
    const [postalCodeAutDestToSelect,setPostalCodeAutDestToSelect]= useState(initialPostalCodetoSelect);  
    const [filteredpostalCodeAutDest, setFilteredpostalCodeAutDest] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeAutDest, setHighlightedIndexPostalCodeAutDest] = useState(-1); // Índice de la opción resaltada 
    const [documentIdAutDestToSelect,setDocumentIdAutDestToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdAutDest, setFilteredDocumentIdAutDest] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdAutDest, setHighlightedIndexDocumentIdAutDest] = useState(-1); // Índice de la opción resaltada 
    const [tradenameAutDestToSelect,setTradenameAutDestToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedAutDest, setFilteredTradenamedAutDest] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedAutDest, setHighlightedIndexTradenamedAutDest] = useState(-1); // Índice de la opción resaltada 
    const [autDestNimaToSelect,setAutDestNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredAutDestNima, setFilteredAutDestNima] = useState([]); // Opciones filtradas
    const [highlightedIndexAutDestNima, setHighlightedIndexAutDestNima] = useState(-1); // Índice de la opción resaltada 
      
    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };
        
    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeAutDest([]);
            setHighlightedIndexPostalCodeAutDest(-1);
        return;
        }
        const filtered = postalCodeAutDestToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeAutDest(filtered);
        setHighlightedIndexPostalCodeAutDest(0);
    }, 300); 
    const handleSelectPostalCodeAutDest = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
            ...formForm,
            default_aut_dest_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            default_aut_dest_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            default_aut_dest_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            default_aut_dest_province_id: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeAutDest([]);
        setHighlightedIndexPostalCodeAutDest(-1);
    }; 
    const handleKeyDownDPostalCodeAutDest = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeAutDest.length === 0 && formForm.default_aut_dest_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeAutDest(postalCodeAutDestToSelect);
            setHighlightedIndexPostalCodeAutDest(0);
        } else {
            setHighlightedIndexPostalCodeAutDest((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeAutDest.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeAutDest((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeAutDest >= 0) {
            if (highlightedIndexPostalCodeAutDest >= 0 && highlightedIndexPostalCodeAutDest < filteredpostalCodeAutDest.length) {
                handleSelectPostalCodeAutDest(filteredpostalCodeAutDest[highlightedIndexPostalCodeAutDest]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeAutDestToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.default_aut_dest_postalcode_code.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm,
                default_aut_dest_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                default_aut_dest_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                default_aut_dest_postalcode_name: DEFAULTPOSTALCODE_NAME,
                default_aut_dest_province_id: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeAutDest([]);
        setHighlightedIndexPostalCodeAutDest(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdAutDest([]);
            setHighlightedIndexDocumentIdAutDest(-1);
            return;
        }
        const filtered = documentIdAutDestToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentid = store.documentid.toUpperCase();
            return documentid.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdAutDest(filtered);
        setHighlightedIndexDocumentIdAutDest(0);
    }, 300);
    const handleSelectDocumentIdAutDest = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
            ...formForm,
            default_aut_dest_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdAutDest([]);
        setHighlightedIndexDocumentIdAutDest(-1);
    }; 
    const handleKeyDownDocumentIdAutDest = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdAutDest.length === 0 && formForm.default_aut_dest_documentid.trim() === "") {
            setFilteredDocumentIdAutDest(documentIdAutDestToSelect);
            setHighlightedIndexDocumentIdAutDest(0);
        } else {
            setHighlightedIndexDocumentIdAutDest((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdAutDest.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDocumentIdAutDest((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdAutDest >= 0) {
        if (highlightedIndexDocumentIdAutDest >= 0 && highlightedIndexDocumentIdAutDest < filteredDocumentIdAutDest.length) {
            handleSelectDocumentIdAutDest(filteredDocumentIdAutDest[highlightedIndexDocumentIdAutDest]);
        }
        } else if (event.key === "Escape") {
            const isValid = documentIdAutDestToSelect.some((store) => {
                if (!store || !store.documentid) return false; 
                const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.default_aut_dest_documentid.toUpperCase();
                return normalizedStoreId === normalizedInputId;
            }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            default_aut_dest_documentid: "",
            }));
        } 
        setFilteredDocumentIdAutDest([]);
        setHighlightedIndexDocumentIdAutDest(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchTradename= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedAutDest([]);
            setHighlightedIndexTradenamedAutDest(-1);
        return;
        }
        const filtered = tradenameAutDestToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedAutDest(filtered);
        setHighlightedIndexTradenamedAutDest(0);
    }, 300); 
    const handleSelectTradeNameAutDest = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        default_aut_dest_tradename: store.tradename || "",
        default_aut_dest_documentid: store.documentid || formForm.default_aut_dest_documentid,
        
        }));
        setFilteredTradenamedAutDest([]);
        setHighlightedIndexTradenamedAutDest(-1);
    }; 
    const handleKeyDownTradenameAutDest = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedAutDest.length === 0 && formForm.default_aut_dest_tradename.trim() === "") {
            setFilteredTradenamedAutDest(tradenameAutDestToSelect);
            setHighlightedIndexTradenamedAutDest(0);
        } else {
            setHighlightedIndexTradenamedAutDest((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedAutDest.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedAutDest((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedAutDest >= 0) {
        if (highlightedIndexTradenamedAutDest >= 0 && highlightedIndexTradenamedAutDest < filteredTradenamedAutDest.length) {
            handleSelectTradeNameAutDest(filteredTradenamedAutDest[highlightedIndexTradenamedAutDest]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameAutDestToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formForm.default_aut_dest_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            default_aut_dest_tradename: "",
            }));
        } 
        setFilteredTradenamedAutDest([]);
        setHighlightedIndexTradenamedAutDest(-1);
        }
    }; 

    // Dentro del componente
    const debouncedHandleSearchAutDestNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredAutDestNima([]);
            setHighlightedIndexAutDestNima(-1);
        return;
        }
        const filtered = autDestNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredAutDestNima(filtered);
        setHighlightedIndexAutDestNima(0);
    }, 300); 
    const handleSelectAutDestNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        default_aut_dest_nima: nt.nima || ""
        }));
        setFilteredAutDestNima([]);
        setHighlightedIndexAutDestNima(-1);
    }; 
    const handleKeyDownAutDestNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredAutDestNima.length === 0 && formForm.default_aut_dest_nima.trim() === "") {
                const filtered = autDestNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredAutDestNima(filtered);
                setHighlightedIndexAutDestNima(0);
            } else {
                setHighlightedIndexAutDestNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredAutDestNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexAutDestNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexAutDestNima >= 0) {
            if (highlightedIndexAutDestNima >= 0 && highlightedIndexAutDestNima < filteredAutDestNima.length) {
                handleSelectAutDestNima(filteredAutDestNima[highlightedIndexAutDestNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = autDestNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.default_aut_dest_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm, 
                default_aut_dest_nima: ""
            }));
        } 
        setFilteredAutDestNima([]);
        setHighlightedIndexAutDestNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index) => {
        const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
        const item = dropdown?.children[index];
        if (item) {
        item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
        }
    };

    const handleBlur = useCallback((event) => {
            if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeAutDest([]);
            setHighlightedIndexPostalCodeAutDest(-1);
            setFilteredDocumentIdAutDest([]);
            setHighlightedIndexDocumentIdAutDest(-1);
            setFilteredTradenamedAutDest([]);
            setHighlightedIndexTradenamedAutDest(-1);  
            setFilteredAutDestNima([]);
            setHighlightedIndexAutDestNima(-1); 
        }
    }, []);

    const handleChangeSelectDocumentType_Aut_Dest = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            default_aut_dest_documnettype_id:event.target.value
        }));
    };
    const handleBlurSelectDocumentType_Aut_Dest = (e) => {
        handleChangeSelectDocumentType_Aut_Dest(e);
    };
    
    const handleChangeSelectRoadType_Aut_Dest = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            default_aut_dest_roadtype_id : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Aut_Dest = (e) => {
        handleChangeSelectRoadType_Aut_Dest(e);
        setErrorsForm(validateForm());
    };
    
    const handleChangeSelectCommunity_Aut_Dest = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            default_aut_dest_community_id : event.target.value   
        }));
    };
    const handleBlurSelectCommunity_Aut_Dest = (e) => {
        handleChangeSelectCommunity_Aut_Dest(e);
        setErrorsForm(validateForm());
    };

    const handleChangeDataEditForm_Aut_Dest = (e) => {
        const { name, value } = e.target;
        setFormForm(formForm => ({
          ...formForm,
          [name]: value,
        }));
    };

    const handleBlurDataEditForm_Aut_Dest = (e) => {
        handleChangeDataEditForm_Aut_Dest(e);
        setErrorsForm(validateForm());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setShowModalSearchStoresNimaAddress(true);
    };

    const searchFormVehicles = (event) => {
        setShowModalSearchVehicles(true);
    };

    const deleteDateAutDest = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            default_aut_dest_id:0,
            default_aut_dest_documnettype_id: "",
            default_aut_dest_documentid:"",
            default_aut_dest_tradename: "",
            default_aut_dest_name: "",
            default_aut_dest_contactname: "",
            default_aut_dest_roadtype_id: Number(DEFAULTROADTYE),
            default_aut_dest_street: "",
            default_aut_dest_country_id: Number(DEFAULTCOUNTRY),
            default_aut_dest_country_name:DEFAULTCOUNTRY_NAME,
            default_aut_dest_province_id: Number(DEFAULTPROVINCE),
            default_aut_dest_province_name:DEFAULTPROVINCE_NAME,
            default_aut_dest_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            default_aut_dest_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            default_aut_dest_postalcode_name: DEFAULTPOSTALCODE_NAME,
            default_aut_dest_community_id: Number(DEFAULTCOMMUNITY),
            default_aut_dest_community_name: DEFAULTCOMMUNITY_NAME,
            default_aut_dest_phone: "",
            default_aut_dest_email: "",
            default_aut_dest_nima: "",
            default_aut_dest_cnae: "",
            default_aut_dest_inscription: "",
            default_aut_dest_opt: 0,
            default_aut_dest_licenseplate: "",
            default_aut_dest_economicactivity:""
        }));
        setErrorsForm(validateForm()); 
    };

    const deleteDataSteetAutDest = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            default_aut_dest_roadtype_id: Number(DEFAULTROADTYE),
            default_aut_dest_street: "",
            default_aut_dest_country_id: Number(DEFAULTCOUNTRY),
            default_aut_dest_country_name:DEFAULTCOUNTRY_NAME,
            default_aut_dest_province_id: Number(DEFAULTPROVINCE),
            default_aut_dest_province_name:DEFAULTPROVINCE_NAME,
            default_aut_dest_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
            default_aut_dest_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            default_aut_dest_postalcode_name: DEFAULTPOSTALCODE_NAME,
            default_aut_dest_community_id: Number(DEFAULTCOMMUNITY),
            default_aut_dest_community_name: DEFAULTCOMMUNITY_NAME,
            default_aut_dest_nima: "",
            default_aut_dest_opt: 0,
            default_aut_dest_inscription: ""
        }));
        setErrorsForm(validateForm());
    };

    const deleteDataVehicleAutDest = (event) => {
        setFormForm(formForm => ({
          ...formForm,
          default_aut_dest_licenseplate: ""
        }));
        setErrorsForm(validateForm());
    };

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`typesdi/getexiststorebynumberdocument/`,token,formForm.default_aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim());
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formForm.default_aut_dest_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
              const getData = await helpHttp().get5(ENDPOINT,`typesdi/getformstorebynumberdocument`,token,formForm.default_aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim(),5);
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData!==undefined && getData!==null && getData!==""){
                    setFormForm(formForm => ({
                        ...formForm,
                        default_aut_dest_id: getData.store_id,
                        default_aut_dest_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                        default_aut_dest_tradename: getData.tradename,
                        default_aut_dest_name: getData.name,
                        default_aut_dest_contactname: getData.contacperson,
                        default_aut_dest_roadtype_id: (getData.roadtype_id===undefined 
                                                || getData.roadtype_id===null  
                                                || getData.roadtype_id===""
                                                || getData.roadtype_id==="0"
                                                || getData.roadtype_id===0)?
                                                Number(DEFAULTROADTYE):getData.roadtype_id,
                        default_aut_dest_street: getData.street,
                        default_aut_dest_country_id: (getData.country_id===undefined 
                                                || getData.country_id===null  
                                                || getData.country_id===""
                                                || getData.country_id==="0"
                                                || getData.country_id===0)?
                                                Number(DEFAULTCOUNTRY):getData.country_id,
                        default_aut_dest_country_name: (getData.country_name===undefined 
                                                || getData.country_name===null  
                                                || getData.country_name==="" )?
                                                DEFAULTCOUNTRY_NAME:getData.country_name,
                        default_aut_dest_province_id: (getData.province_id===undefined 
                                                || getData.province_id===null  
                                                || getData.province_id===""
                                                || getData.province_id==="0"
                                                || getData.province_id===0)?
                                                Number(DEFAULTPROVINCE):getData.province_id,
                        default_aut_dest_province_name: (getData.province_name===undefined 
                                                || getData.province_name===null  
                                                || getData.province_name==="" )?
                                                DEFAULTPROVINCE_NAME:getData.province_name, 
                        default_aut_dest_postalcode_id: (getData.postalcode_id===undefined 
                                                    || getData.postalcode_id===null  
                                                    || getData.postalcode_id===""
                                                    || getData.postalcode_id==="0"
                                                    || getData.postalcode_id===0)?
                                                    Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                        default_aut_dest_postalcode_code: (getData.postalcode_code===undefined 
                                                    || getData.postalcode_code===null  
                                                    || getData.postalcode_code==="" )?
                                                        DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                        default_aut_dest_postalcode_name:(getData.postalcode_name===undefined 
                                                    || getData.postalcode_name===null  
                                                    || getData.postalcode_name==="" )?
                                                        DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                        default_aut_dest_community_id: (getData.community_id===undefined 
                                                    || getData.community_id===null  
                                                    || getData.community_id===""
                                                    || getData.community_id==="0"
                                                    || getData.community_id===0)?
                                                    Number(DEFAULTCOMMUNITY):getData.community_id,
                        default_aut_dest_community_name:(getData.community_name===undefined 
                                                    || getData.community_name===null  
                                                    || getData.community_name==="" )?
                                                        DEFAULTCOMMUNITY_NAME:getData.community_name,  
                        default_aut_dest_phone: getData.phone,
                        default_aut_dest_email: getData.email,
                        default_aut_dest_nima: getData.nima_aut_dest,
                        default_aut_dest_cnae: getData.cnae,
                        default_aut_dest_inscription: getData.pygr_aut_dest,
                        default_aut_dest_opt: getData.opt_dest_tras,
                        default_aut_dest_licenseplate: getData.licenseplate,
                        default_aut_dest_economicactivity:getData.economicactivity
                    }));
                }  
            }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formForm.default_aut_dest_documentid && formForm.default_aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            }  
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formForm.default_aut_dest_documentid,errorsForm.default_aut_dest_documentid,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,DEFAULTPROVINCE,setFormForm,formForm.default_aut_dest_id,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);
     
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdAutDest = async () => {
            try {
            const getData = await helpHttp().get2(ENDPOINT,`typesdi/getlistdocumentidtypesdi/`,token,
                (formForm.default_aut_dest_documentid!==undefined && formForm.default_aut_dest_documentid!==null && formForm.default_aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.default_aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                setDocumentIdAutDestToSelect(getData); 
            }
            } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formForm.default_aut_dest_documentid && formForm.default_aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdAutDest();
            }
        } else{
            setDocumentIdAutDestToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.default_aut_dest_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameAutDest = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`typesdi/getlisttradenametypesdi/`,token,
                    (formForm.default_aut_dest_tradename!==undefined && formForm.default_aut_dest_tradename!==null && formForm.default_aut_dest_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.default_aut_dest_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameAutDestToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formForm.default_aut_dest_tradename && formForm.default_aut_dest_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameAutDest();
            }
        } else{
            setTradenameAutDestToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.default_aut_dest_tradename,expanded]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeAutDest = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`typesdi/getlistpostalcodetypesdi/`,token,
                    (formForm.default_aut_dest_postalcode_code!==undefined && formForm.default_aut_dest_postalcode_code!==null && formForm.default_aut_dest_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.default_aut_dest_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeAutDestToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formForm.default_aut_dest_postalcode_code && formForm.default_aut_dest_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeAutDest();
            } 
        } else{
            setPostalCodeAutDestToSelect(initialPostalCodetoSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.default_aut_dest_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormForm]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaAutDest = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchtypesdi/getlistnimas`,token,formForm.default_aut_dest_id, 
                    (formForm.default_aut_dest_nima!==undefined && formForm.default_aut_dest_nima!==null && formForm.default_aut_dest_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.default_aut_dest_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setAutDestNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formForm.default_aut_dest_id && formForm.default_aut_dest_id!==null && formForm.default_aut_dest_id!=="" && formForm.default_aut_dest_id!=="0" && formForm.default_aut_dest_id!==0){
                fetchDataNimaAutDest(); 
            }else{
                setAutDestNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm,expanded,setFormForm,formForm.default_aut_dest_id]);
    
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_DocuentType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="default_aut_dest_documnettype_id"
                        name="default_aut_dest_documnettype_id"
                        value={ (formForm.default_aut_dest_documnettype_id === undefined || formForm.default_aut_dest_documnettype_id ===null || formForm.default_aut_dest_documnettype_id ===""
                            || formForm.default_aut_dest_documnettype_id ==="0" || formForm.default_aut_dest_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formForm.default_aut_dest_documnettype_id}
                        inputProps={{ style: {width: 200,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectDocumentType_Aut_Dest}
                        onChange={handleChangeSelectDocumentType_Aut_Dest}
                        helperText={errorsForm.default_aut_dest_documnettype_id!=null && errorsForm.default_aut_dest_documnettype_id!==""?t(errorsForm.default_aut_dest_documnettype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formForm.default_aut_dest_documnettype_id === undefined || formForm.default_aut_dest_documnettype_id ===null || formForm.default_aut_dest_documnettype_id ===""
                                || formForm.default_aut_dest_documnettype_id ==="0" || formForm.default_aut_dest_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formForm.default_aut_dest_documnettype_id
                        }}>
                        <option key={0} value=""/>
                        {documentTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </TextField>  
                    {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CIF')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="default_aut_dest_documentid"
                            name="default_aut_dest_documentid"
                            value={formForm.default_aut_dest_documentid}
                            onChange={(e) => {
                                setFormForm(prev => ({
                                    ...prev,
                                    default_aut_dest_documentid: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDocumentId(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDocumentIdAutDest}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.default_aut_dest_documentid!=null && errorsForm.default_aut_dest_documentid!==""?t(errorsForm.default_aut_dest_documentid):t('PlaceHolder_FORM_CIF')}
                            placeholder={t('PlaceHolder_FORM_CIF')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?283:323,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        /> 
                        {/* Desplegable dinámico */}
                        {filteredDocumentIdAutDest.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "400px",
                                overflowY: "auto",
                                width: "250%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                            {filteredDocumentIdAutDest.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectDocumentIdAutDest(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexDocumentIdAutDest ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentIdAutDest ? "white" : "black",
                                    }}
                                >
                                    {store.documentid} - {store.tradename}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>  
                     &nbsp;&nbsp;
                    <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDateAutDest}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton> 
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                        <IconButton  size="small" className="edit-select-button" onClick={searchFormStore}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>  
                    }
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="default_aut_dest_tradename"
                            name="default_aut_dest_tradename"
                            value={formForm.default_aut_dest_tradename}
                            onChange={(e) => {
                                setFormForm(prev => ({
                                    ...prev,
                                    default_aut_dest_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradename(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameAutDest}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.default_aut_dest_tradename!=null && errorsForm.default_aut_dest_tradename!==""?t(errorsForm.default_aut_dest_tradename):t('PlaceHolder_FORM_TRADENAME')}
                            placeholder={t('PlaceHolder_FORM_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?858:834,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredTradenamedAutDest.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "800px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedAutDest.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameAutDest(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedAutDest ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedAutDest ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NAME')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField
                    id="default_aut_dest_name" 
                    name="default_aut_dest_name"
                    value={formForm.default_aut_dest_name}
                    inputProps={{ style: {width: i18n.language==='es'?812:857,  fontSize: '18px', }, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    label={errorsForm.default_aut_dest_name!=null && errorsForm.default_aut_dest_name!==""?t(errorsForm.default_aut_dest_name):t('PlaceHolder_FORM_NAME')}
                    placeholder={t('PlaceHolder_FORM_NAME')}
                    variant="standard"
                    onBlur={handleBlurDataEditForm_Aut_Dest}
                    onChange={handleChangeDataEditForm_Aut_Dest} 
                />
                </div>
            </div> 
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CONTACT')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField
                    id="default_aut_dest_contactname" 
                    name="default_aut_dest_contactname"
                    value={formForm.default_aut_dest_contactname}
                    inputProps={{ style: {width: i18n.language==='es'?795:840,  fontSize: '18px', }, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    label={errorsForm.default_aut_dest_contactname!=null && errorsForm.default_aut_dest_contactname!==""?t(errorsForm.default_aut_dest_contactname):t('PlaceHolder_FORM_CONTACT')}
                    placeholder={t('PlaceHolder_FORM_CONTACT')}
                    variant="standard"
                    onBlur={handleBlurDataEditForm_Aut_Dest}
                    onChange={handleChangeDataEditForm_Aut_Dest} 
                />
                </div>
            </div> 
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_dest_roadtype_id"
                        name="default_aut_dest_roadtype_id"
                        value={ (formForm.default_aut_dest_roadtype_id === undefined || formForm.default_aut_dest_roadtype_id ===null || formForm.default_aut_dest_roadtype_id ===""
                            || formForm.default_aut_dest_roadtype_id ==="0" || formForm.default_aut_dest_roadtype_id ===0)?Number(DEFAULTROADTYE):formForm.default_aut_dest_roadtype_id}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Aut_Dest}
                        onChange={handleChangeSelectRoadType_Aut_Dest} 
                        helperText={errorsForm.default_aut_dest_roadtype_id!=null && errorsForm.default_aut_dest_roadtype_id!==""?t(errorsForm.default_aut_dest_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formForm.default_aut_dest_roadtype_id === undefined || formForm.default_aut_dest_roadtype_id ===null || formForm.default_aut_dest_roadtype_id ===""
                                || formForm.default_aut_dest_roadtype_id ==="0" || formForm.default_aut_dest_roadtype_id ===0)?Number(DEFAULTROADTYE): formForm.default_aut_dest_roadtype_id
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Address')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_dest_street" 
                        name="default_aut_dest_street"
                        value={formForm.default_aut_dest_street}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.default_aut_dest_street!=null && errorsForm.default_aut_dest_street!==""?t(errorsForm.default_aut_dest_street):t('PlaceHolder_FORM_Address')}
                        placeholder={t('PlaceHolder_FORM_Address')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Dest}
                        onChange={handleChangeDataEditForm_Aut_Dest} 
                    />
                </div>
               &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataSteetAutDest}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formForm.default_aut_dest_documentid!==undefined && formForm.default_aut_dest_documentid!=="") ?
                    <IconButton  size="small" className={`edit-${
                        (formForm.default_aut_dest_id===undefined
                        || formForm.default_aut_dest_id===""
                        || formForm.default_aut_dest_id==="0"
                        || formForm.default_aut_dest_id===0 )
                        ? "noselect-button": "select-button" }`}
                        disabled={formForm.default_aut_dest_id===undefined
                        || formForm.default_aut_dest_id===""
                        || formForm.default_aut_dest_id==="0"
                        || formForm.default_aut_dest_id===0 }
                                onClick={searchFormStoreAddress}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton> 
                }
            </div>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="default_aut_dest_postalcode_code"
                            name="default_aut_dest_postalcode_code"
                            value={formForm.default_aut_dest_postalcode_code}
                            onChange={(e) => {
                                    setFormForm(prev => ({
                                    ...prev,
                                    default_aut_dest_postalcode_code: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCode(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeAutDest}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formForm.default_aut_dest_postalcode_code.trim().toUpperCase();
                                    const matchedPostal = postalCodeAutDestToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormForm((prev) => ({
                                            ...prev,
                                            default_aut_dest_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            default_aut_dest_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            default_aut_dest_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            default_aut_dest_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormForm((prev) => ({
                                            ...prev,
                                            default_aut_dest_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                            default_aut_dest_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                            default_aut_dest_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                            default_aut_dest_province_id: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setFilteredpostalCodeAutDest([]);
                                    setHighlightedIndexPostalCodeAutDest(-1);
                                }
                            }}
                            label={errorsForm.default_aut_dest_postalcode_code!=null && errorsForm.default_aut_dest_postalcode_code!==""?t(errorsForm.default_aut_dest_postalcode_code):t('Text_FORM_PostalCode')}
                            placeholder={t('Text_FORM_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeAutDest.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeAutDest.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeAutDest(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeAutDest ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeAutDest ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_dest_postalcode_name" 
                        name="default_aut_dest_postalcode_name"
                        value={formForm.default_aut_dest_postalcode_name}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.default_aut_dest_postalcode_name!=null && errorsForm.default_aut_dest_postalcode_name!==""?t(errorsForm.default_aut_dest_postalcode_name):t('Text_FORM_Locality')}
                        placeholder={t('Text_FORM_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Dest}
                        onChange={handleChangeDataEditForm_Aut_Dest}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_dest_community_id"
                        name="default_aut_dest_community_id"
                        value={ (formForm.default_aut_dest_community_id === undefined || formForm.default_aut_dest_community_id ===null || formForm.default_aut_dest_community_id ===""
                            || formForm.default_aut_dest_community_id ==="0" || formForm.default_aut_dest_community_id ===0)?Number(DEFAULTCOMMUNITY):formForm.default_aut_dest_community_id}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunity_Aut_Dest}
                        onChange={handleChangeSelectCommunity_Aut_Dest}
                        helperText={errorsForm.default_aut_dest_community_id!=null  && errorsForm.default_aut_dest_community_id!==""?t(errorsForm.default_aut_dest_community_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formForm.default_aut_dest_community_id === undefined || formForm.default_aut_dest_community_id ===null || formForm.default_aut_dest_community_id ===""
                                || formForm.default_aut_dest_community_id ==="0" || formForm.default_aut_dest_community_id ===0)?Number(DEFAULTCOMMUNITY): formForm.default_aut_dest_community_id
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Phone')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                     <TextField
                        id="default_aut_dest_phone" 
                        name="default_aut_dest_phone"
                        value={formForm.default_aut_dest_phone}
                        inputProps={{ style: {width: 180,  fontSize: '18px', }, maxLength: 30 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.default_aut_dest_phone!=null && errorsForm.default_aut_dest_phone!==""?t(errorsForm.default_aut_dest_phone):t('PlaceHolder_FORM_Phone')}
                        placeholder={t('PlaceHolder_FORM_Phone')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Dest}
                        onChange={handleChangeDataEditForm_Aut_Dest} 
                    /> 
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Email')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="default_aut_dest_email" 
                        name="default_aut_dest_email"
                        value={formForm.default_aut_dest_email}
                        inputProps={{ style: {width: i18n.language==='es'?319:335 ,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.default_aut_dest_email!=null && errorsForm.default_aut_dest_email!==""?t(errorsForm.default_aut_dest_email):t('PlaceHolder_FORM_Email')}
                        placeholder={t('PlaceHolder_FORM_Email')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Dest}
                        onChange={handleChangeDataEditForm_Aut_Dest} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NIMA')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="default_aut_dest_nima"
                            name="default_aut_dest_nima"
                            value={formForm.default_aut_dest_nima}
                            onChange={(e) => {
                                setFormForm(prev => ({
                                ...prev,
                                default_aut_dest_nima: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchAutDestNima(e.target.value);
                            }}
                            onKeyDown={handleKeyDownAutDestNima}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.default_aut_dest_nima!=null && errorsForm.default_aut_dest_nima!==""?t(errorsForm.default_aut_dest_nima):t('PlaceHolder_FORM_NIMA')}
                            placeholder={t('PlaceHolder_FORM_NIMA')}
                            variant="standard"
                            inputProps={{ style: {width: 133,  fontSize: '18px'}, maxLength: 50 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredAutDestNima.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredAutDestNima.map((nt, index) => (
                                <MenuItem
                                    key={nt.id}
                                    onClick={() => handleSelectAutDestNima(nt)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexAutDestNima ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexAutDestNima ? "white" : "black",
                                    }}
                                >
                                    {nt.nima}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                        &nbsp;&nbsp;
                    {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formForm.default_aut_dest_documentid!==undefined && formForm.default_aut_dest_documentid!=="") ?
                        <IconButton  size="small" className={`edit-${
                            (formForm.default_aut_dest_id===undefined
                            || formForm.default_aut_dest_id===""
                            || formForm.default_aut_dest_id==="0"
                            || formForm.default_aut_dest_id===0
                            )? "noselect-button": "select-button" }`}
                            disabled={formForm.default_aut_dest_id===undefined
                            || formForm.default_aut_dest_id===""
                            || formForm.default_aut_dest_id==="0"
                            || formForm.default_aut_dest_id===0 } 
                            onClick={searchFormStoreNimaAddress}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>:
                        <IconButton  size="small" className="edit-noselect-button" disabled>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>  
                    } 
                </div>
            </div> 
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_INSCRIPTION')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_dest_inscription" 
                        name="default_aut_dest_inscription"
                        value={formForm.default_aut_dest_inscription}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: 350,  fontSize: '18px'}, maxLength: 50 }}
                        label={errorsForm.default_aut_dest_inscription!=null && errorsForm.default_aut_dest_inscription!==""?t(errorsForm.default_aut_dest_inscription):t('PlaceHolder_FORM_INSCRIPTION')}
                        placeholder={t('PlaceHolder_FORM_INSCRIPTION')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Dest}
                        onChange={handleChangeDataEditForm_Aut_Dest} 
                    /> 
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_OPT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_dest_opt"
                        name="default_aut_dest_opt"
                        value={ (formForm.default_aut_dest_opt === undefined || formForm.default_aut_dest_opt ===null || formForm.default_aut_dest_opt ===""
                            || formForm.default_aut_dest_opt ==="0" || formForm.default_aut_dest_opt ===0)?0:formForm.default_aut_dest_opt}
                        inputProps={{ style: {width: i18n.language==='es'?194:171,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurDataEditForm_Aut_Dest}
                        onChange={handleChangeDataEditForm_Aut_Dest} 
                        helperText={errorsForm.default_aut_dest_opt!=null?t(errorsForm.default_aut_dest_opt):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formForm.default_aut_dest_opt === undefined || formForm.default_aut_dest_opt ===null || formForm.default_aut_dest_opt ===""
                                || formForm.default_aut_dest_opt ==="0" || formForm.default_aut_dest_opt ===0)?0: formForm.default_aut_dest_opt
                        }}>
                        <option key={0} value=""/>
                        {optTypeToSelect.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.code} - {option.namees.substring(0,20)}
                        </option>
                        ))}
                    </TextField>    
                </div>
            </div>  
             
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CNAE')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_dest_cnae" 
                        name="default_aut_dest_cnae"
                        value={formForm.default_aut_dest_cnae}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: (i18n.language==='es'?388:399),  fontSize: '18px'}, maxLength: 100 }}
                        label={errorsForm.default_aut_dest_cnae!=null && errorsForm.default_aut_dest_cnae!==""?t(errorsForm.default_aut_dest_cnae):t('PlaceHolder_FORM_CNAE')}
                        placeholder={t('PlaceHolder_FORM_CNAE')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Dest}
                        onChange={handleChangeDataEditForm_Aut_Dest} 
                    />
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                   <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Economicactivity')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_dest_economicactivity" 
                        name="default_aut_dest_economicactivity"
                        value={formForm.default_aut_dest_economicactivity}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: i18n.language==='es'?397:823,  fontSize: '18px'}, maxLength: 100 }}
                        label={errorsForm.default_aut_dest_economicactivity!=null && errorsForm.default_aut_dest_economicactivity!==""?t(errorsForm.default_aut_dest_economicactivity):t('PlaceHolder_FORM_Economicactivity')}
                        placeholder={t('PlaceHolder_FORM_Economicactivity')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Dest}
                        onChange={handleChangeDataEditForm_Aut_Dest} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Vehicles')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_dest_licenseplate" 
                        name="default_aut_dest_licenseplate"
                        value={formForm.default_aut_dest_licenseplate}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        label={errorsForm.default_aut_dest_licenseplate!=null?t(errorsForm.default_aut_dest_licenseplate):t('PlaceHolder_FORM_Vehicles')}
                        placeholder={t('PlaceHolder_FORM_Vehicles')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Dest}
                        onChange={handleChangeDataEditForm_Aut_Dest} 
                    />
                    &nbsp;&nbsp;
                    <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDataVehicleAutDest}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton>
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                        <IconButton  size="small" className={`edit-${
                            (formForm.default_aut_dest_id===undefined
                                    || formForm.default_aut_dest_id===""
                                    || formForm.default_aut_dest_id==="0"
                                    || formForm.default_aut_dest_id===0)? "noselect-button": "select-button" }`}
                            disabled={(formForm.default_aut_dest_id===undefined
                                    || formForm.default_aut_dest_id===""
                                    || formForm.default_aut_dest_id==="0"
                                    || formForm.default_aut_dest_id===0)}  onClick={searchFormVehicles}> 
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    }
                </div>
            </div>
            <TypesDISearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Aut_Dest"}
                setFormForm={setFormForm}
            />
             <TypesDISearchStoresAddress
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={"Aut_Dest"}
                setFormForm={setFormForm}
                titleTable={formForm.default_aut_dest_tradename}
                store_id={formForm.default_aut_dest_id}
                priority={5}
            />
            <TypesDISearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Aut_Dest"}
                setFormForm={setFormForm}
                titleTable={formForm.default_aut_dest_tradename}
                store_id={formForm.default_aut_dest_id} 
            />
            <TypesDISearchVehicles
                showModalSearchVehicles={showModalSearchVehicles}
                setShowModalSearchVehicles={setShowModalSearchVehicles}
                selectStores={"Aut_Dest"}
                setFormForm={setFormForm}
                titleTable={formForm.default_aut_dest_tradename}
                store_id={formForm.default_aut_dest_id}
            />
        </> 
    )
}

TypeDICreateOrEditAutDest.propTypes = {
    formForm: PropTypes.object.isRequired,
    setFormForm: PropTypes.func.isRequired,  
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateForm: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired
  };
  
  export default TypeDICreateOrEditAutDest;

